import { LitElement, html, css } from 'lit';
import * as pbi from 'powerbi-client';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
@customElement('powerbi-embed-element')

export class PowerbiEmbedElement extends JobindsatsElement(LitElement) {
    static styles = [css`
        .report-iframe {
            margin-bottom: 10px;
            margin-top: 25px;
            display: flex;
            gap: 50px;
            flex-direction: column;
            border: 2px solid black;
            padding: 4px;

            
        }
        .report-iframe iframe {
            width: 100%;
            height: 100%;
            aspect-ratio: 16/9;
            border: none;
        }
        .report-actions {
            margin-bottom: 30px;
            a {
                margin-right: 2em;
            }
        }
`];

    static instance = 0;

    @property({
        attribute: 'id',
    })
    id = ++PowerbiEmbedElement.instance + 'lit-embed';
    
    @property({ type: String })
    token : string | undefined;

    @property({ type: String })
    reportid = "";

    @property({
        type: String,
        hasChanged(newVal: string, oldVal: string) {
            return false;  // don't reload component/report when updating token
        }
    })
    tokenexpiration = Date.now().toString();
    
    @property({ type: String })
    embedurl: string | undefined;

    @property({ type: Boolean })
    active: boolean = false;

    @property({ type: Boolean, reflect: true })
    cookieConsentGiven: boolean = window.cookieTractor.consent.contains(window.cookieTractor.category.statistical);

    @property({ attribute: false, type: String })
    reportElementId : string = "";

    @property({ attribute: false, type: pbi.Report })
    report : pbi.Report | undefined;

    @property({ attribute: false, type: Number })
    minutes_before_expiration = 20;

    @property({ attribute: false, type: Number })
    interval_time_secs = 180;


   constructor() {
       super();
      
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('CookieConsentGiven', (e: Event) => this._handleConsentUpdated(e));
        const that = this;

        // Add a listener to make sure token is updated after tab was inactive
        document.addEventListener("visibilitychange", function () {
            // Check the access token when the tab is visible
            if (!document.hidden) {
                console.log("visibility changed");
                that.checkTokenAndUpdate()
            }
        });
        console.log("REGISTER TOKEN UPDATER")
        // Set an interval to check the access token expiration, and update if needed
        setInterval(() => that.checkTokenAndUpdate(), this.interval_time_secs * 1000);
    }

    disconnectedCallback() {
        window.removeEventListener('CookieConsentGiven', (e: Event) => this._handleConsentUpdated(e));
        const that = this;
        document.removeEventListener("visibilitychange", function () {
            // Check the access token when the tab is visible
            if (!document.hidden) {
                that.checkTokenAndUpdate()
            }
        });
        super.disconnectedCallback();
    }

    render() {
        // return html`Hello world!<div @click="${this._flipActive}">Active fli: ${this.active}</div>`;
        if (this.cookieConsentGiven) {
            //console.log("RENDER WORLD 2: " + this.reportid + this.embedurl + this.token);
            // Read embed application token from Model
            const accessToken = this.token; // this.embedreportconfig.EmbedToken.token;

            // You can embed different reports as per your need by changing the index
            // Read embed URL from Model
            const embedUrl = this.embedurl; // this.embedreportconfig.EmbedReports[0].EmbedUrl;

            // Read report Id from Model
            const embedReportId = this.reportid; //this.embedreportconfig.EmbedReports[0].ReportId;

            // Use the token expiry to regenerate Embed token for seamless end user experience
            // Refer https://aka.ms/RefreshEmbedToken
            const tokenExpiry = this.tokenexpiration; //this.embedreportconfig.EmbedToken.expiration;

            // Get models. models contains enums that can be used.
            const models = pbi.models;
            let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

            // Embed configuration used to describe the what and how to embed.
            // This object is used when calling powerbi.embed.
            // This also includes settings and options such as filters.
            // You can find more information at https://github.com/Microsoft/PowerBI-JavaScript/wiki/Embed-Configuration-Details.
            const config = {
                type: 'report',
                tokenType: models.TokenType.Embed,
                accessToken: accessToken,
                embedUrl: embedUrl,
                id: embedReportId,
                permissions: models.Permissions.All,
                viewMode: models.ViewMode.View,
                visualName: "",
                settings: {
                    // Enable this setting to remove gray shoulders from embedded report
                    background: models.BackgroundType.Default,
                    localeSettings: {
                        language: "da-dk"
                    },

                    filterPaneEnabled: false,
                    navContentPaneEnabled: false,
                    bookmarksPaneEnabled: false,
                    fullscreen: true,
                    bars: {
                        statusBar: {
                            visible: false
                        }
                    },
                    commands: [
                        { spotlight: { displayOption: 2 } },
                        { sort: { displayOption: 2 } },
                        { insightsAnalysis: { displayOption: 2 } }
                    ],
                    layoutType: models.LayoutType.Custom,
                    customLayout: {
                        displayOption: models.DisplayOption.FitToPage
                    }
                }
            };

            // Embed the report and display it within the div container.
            this.reportElementId = "report-" + embedReportId;
            var reportDiv = document.createElement("div");
            reportDiv.id = this.reportElementId;
            this.report = <pbi.Report>powerbi.embed(reportDiv, config);

            // set up print and fullscreen button handler
            const report = this.report;
            report.on('buttonClicked', async function (event) {
                console.log("Event - buttonClicked:\n", event.detail);
                const eventDetails = <IPbiButtonClickedEventDetails>event.detail;

                if (eventDetails.type === "PageNavigation") {
                    switch (eventDetails.title?.toLowerCase()) {

                        case "fullscreen":
                            if (document.fullscreen) {
                                await document.exitFullscreen();
                            } else {
                                await report.fullscreen();
                            }
                            break;

                        case "print":
                            if (document.fullscreen) {
                                await document.exitFullscreen();
                                await delay(500);
                            }
                            await report.print();
                            break;

                        default:
                            break;
                    }
                }
            });

            return html`
                <div class="report-iframe">
                    ${reportDiv}
                </div>
            `;
        } else {
            return html`
                <div class="report-iframe">
                    <rapportbankCookieCheck style="line-height: 2; background-color: #ffe7a6;">
                        <b>
                            <i>
                            Kære bruger, <br />
                            I denne boks plejer den valgte rapport at være tilgængelig. Det er den imidlertid ikke, da det for at få adgang til Power BI rapporterne er nødvendigt at acceptere cookies på Jobindsats.
                            <br>
                            <br>
                            Klik på <a href="javascript:cookieTractor.openConsentSettings()">her </a> for at acceptere cookies, så du kan se Power BI-rapporterne på Jobindsats.<br>
                            Vær opmærksom på at genindlæse siden (F5) efter at samtykket er accepteret.<br /> <br />

                            Hvis du ikke accepterer brugen af cookies vil Power BI-rapporterne ikke være tilgængelige, og du henvises til <a href ="https://jobindsats.dk/databank/">Databanken på Jobindsats </a> . Her vil du kunne hente data uden anvendelse af cookies.
                            <br>
                            <br>
                            Du kan til enhver tid ændre dit samtykke ved at trykke  på <a href="javascript:cookieTractor.openConsentSettings()">"Ændre samtykke til brug af cookies" </a> nederst på siden.
                            </i>
                        </b>
                    </rapportbankCookieCheck>
                </div>
            `;
        }
       
    }

    private async checkTokenAndUpdate() {
        console.log("Checking token");
        // Get the current time
        const currentTime = Date.now();
        const expiration = Date.parse(this.tokenexpiration);

        // Time until token expiration in milliseconds
        const timeUntilExpiration = expiration - currentTime;
        const timeToUpdate = this.minutes_before_expiration * 60 * 1000;

        // Update the token if it is about to expired
        if (timeUntilExpiration <= timeToUpdate) {
            console.log("Updating report access token");
            await this.updateToken();
        }
    }

    private async updateToken() {
        // Generate a new embed token or refresh the user Azure AD access token
        let newAccessToken = await this.getNewUserAccessToken(this.reportid);
        // Update the new token expiration time
        this.tokenexpiration = newAccessToken.expiration;

        // Set the new access token
        await this.report?.setAccessToken(newAccessToken.token);
        //console.log("Refreshed token : " + JSON.stringify(newAccessToken));
    }

    private async getNewUserAccessToken(reportId: string): Promise<IPbiAccessToken> {
        return await fetch('/umbraco/api/PowerBIReportEmbedApi/RenewAccessToken?reportId=' + reportId).then(response => {
            return response.json().then(data => { return <IPbiAccessToken>data});
        });
    }


    private _handleConsentUpdated(e: Event) {
        console.log("handle consent updated..");
        var allowStatistical = window.cookieTractor.consent.contains(window.cookieTractor.category.statistical);
        console.log(allowStatistical);
        this.cookieConsentGiven = allowStatistical;
    }
}

interface IPbiButtonClickedEventDetails {
    id: string;
    title?: string;
    type?: string;
    bookmark?: string;
}

interface IPbiAccessToken {
    token: string;
    tokenId: string;
    expiration: string;
}

function delay(ms: number | undefined) {
    return new Promise(resolve => setTimeout(resolve, ms));
}